"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isExperimentAssignment(object) {
    return checkExperimentAssignment(object).fulfilled;
}
exports.isExperimentAssignment = isExperimentAssignment;
function checkExperimentAssignment(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("experimentId"), Check_1.hasAny("variant")).withOptions(options).explain();
}
exports.checkExperimentAssignment = checkExperimentAssignment;
//# sourceMappingURL=ExperimentAssignment.js.map